import Stack from '~/common/components/Stacks/Stack';
import Text from '~/common/components/Texts/Text';

type ConsideredFormulasProps = {
  consideredFormulas: {
    formula?: string;
    formulaType?: string;
    incomeValue?: number;
    isFormulaUsed?: boolean;
  }[];
};

export default function ConsideredFormulas({
  consideredFormulas,
}: Readonly<ConsideredFormulasProps>) {
  return (
    <Stack component="ul">
      {consideredFormulas.map((consideredFormula) => (
        <Text
          fontWeight={consideredFormula.isFormulaUsed ? 'bold' : 'normal'}
          listStyleType="none"
          lineHeight="1"
          as="li"
          key={consideredFormula.formulaType}
        >
          {consideredFormula.formula}
        </Text>
      ))}
    </Stack>
  );
}
